import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { formatShortDate, getInitials } from "../common/utils";
import { backgrounds, borders } from "../theme/theme";

interface EngagementListItemProps {
  engagement: any;
  onEngagementClick?: (publicId: string) => void;
}

function EngagementListItem(props: EngagementListItemProps) {
  const { engagement, onEngagementClick } = props;
  const isEnded = !!engagement.endDate;

  return (
    <ListItemButton
      onClick={() => {
        if (onEngagementClick) {
          onEngagementClick(engagement.publicId);
        }
      }}
      sx={{
        px: 2,
        py: 1.5,
        borderRadius: 1,
        mb: 1,
        border: "1px solid",
        borderColor: borders.light,
        "&:hover": {
          backgroundColor: backgrounds.hover,
          borderColor: borders.main,
        },
      }}
    >
      <Avatar
        sx={{
          bgcolor: isEnded ? "grey.400" : "primary.main",
          width: 44,
          height: 44,
          mr: 2,
          fontSize: 16,
          fontWeight: 600,
        }}
      >
        {getInitials(engagement.clientName)}
      </Avatar>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 0.5,
          }}
        >
          <Typography variant="body1" fontWeight={600} noWrap>
            {engagement.clientName}
          </Typography>
          {isEnded ? (
            <Chip label="Ended" size="small" color="default" />
          ) : (
            <Chip label="Active" size="small" color="success" />
          )}
        </Box>

        <Typography variant="body2" color="text.secondary" noWrap>
          {isEnded ? (
            <>Ended {formatShortDate(engagement.endDate)}</>
          ) : (
            <>{engagement.numberOfHoursPerWeek} hrs/week</>
          )}
          {" · "}
          {engagement.currency}
          {engagement.hourlyRate}/hr
          {engagement.shortDescription && ` · ${engagement.shortDescription}`}
        </Typography>
      </Box>

      <ChevronRightIcon sx={{ color: "text.secondary", ml: 1 }} />
    </ListItemButton>
  );
}

export default EngagementListItem;
